import { isLocal, isProduction, isBlueGreen } from "@ctra/utils";

/**
 * Redirect URL for the main app
 * @type {string}
 */
export const redirectURL = isLocal()
  ? "http://localhost:3000"
  : isBlueGreen()
  ? "https://deploy-app.connecterra.ai"
  : `https://${isProduction() ? "" : "staging-"}app.connecterra.ai`;
